<template>
  <IdleTracker v-if="$store.getters['session/isLogged']">
    <b-navbar v-if="$store.state.healthyHabits.isReadOnlyView" sticky class="navbar-healthy-habits navbar-healthy-habits-commom navbar-login" toggleable="xl">
        <div class="navbar-items-align">
          <b-nav-item class="d-block my-auto my-auto pr-2" @click="onBackButtonClick">
            <base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/caret.svg" svgClasses="rotate-180" width="20" height="20"/>
          </b-nav-item>
            <b-navbar-brand @click.stop="goPatientMenu()" class="cursor-pointer mx-auto mx-lg-0"><img class="navbar-brand-img" :style="getLogoStyles" :src="getLogo"/></b-navbar-brand>
        </div>
        <base-button outline fitContent @click="closeTab">{{$t('close')}}</base-button>
    </b-navbar>
    <b-navbar v-else sticky class="navbar-healthy-habits navbar-healthy-habits-commom" toggleable="xl">
        <div class="navbar-items-align">
          <b-nav-item class="d-block my-auto my-auto pr-2" @click="onBackButtonClick">
            <base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/caret.svg" svgClasses="rotate-180" width="20" height="20"/>
          </b-nav-item>
            <b-navbar-brand @click.stop="goPatientMenu()" class="cursor-pointer mx-auto mx-lg-0"><img class="navbar-brand-img" :style="getLogoStyles" :src="getLogo"/></b-navbar-brand>
            <!-- <div v-if="$store.state.healthyHabits.table.data && $store.state.healthyHabits.table.data.items && !showInSubmenu" class="trophy-menu-outside cursor-default-trophy"><b-icon-trophy class="blue mr-2" scale="1.3"></b-icon-trophy><span>{{$store.state.healthyHabits.bestStreak}}</span></div> -->
            <!-- <div v-if="!showInSubmenu" class="doubs-menu-outside" @click.stop="$router.push({ name: 'healthyHabitsFaqs' })"><b-icon-question-circle class="blue" scale="1.3"></b-icon-question-circle></div>
            <div v-if="!showInSubmenu" @click.stop="showSettingModal()" class="config-menu-outside"><b-icon-gear-fill class="blue" scale="1.3"></b-icon-gear-fill></div> -->
            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        </div>
        <b-collapse class="navbar-mobile-fixed navCollapse" id="nav-collapse">
          <b-navbar-nav class="navbar-submenu ml-auto">
            <!-- <b-nav-item v-if="$store.state.healthyHabits.table.data && $store.state.healthyHabits.table.data.items && showInSubmenu" class="my-auto cursor-default-trophy"><b-icon-trophy class="blue" scale="1.3"></b-icon-trophy>&nbsp;&nbsp;<span>{{$store.state.healthyHabits.bestStreak}}</span></b-nav-item> -->
            <b-nav-item @click.stop="$router.push({ name: 'healthyHabitsFaqs' })"><base-button outline fitContent>{{$t('doubts')}}</base-button></b-nav-item>
            <b-nav-item @click.stop="showSettingModal()"><base-button outline fitContent>{{$t('setting')}}</base-button></b-nav-item>
            <b-nav-item v-if="!showInSubmenu"><base-button outline fitContent>{{$store.state.healthyHabits.setting.nick}}</base-button></b-nav-item>
            <b-nav-item v-if="showInSubmenu" class="my-auto">
            <base-button style="background-color:transparent;width:10rem" class="btn-dropdown">
                <dropdown v-if="$store.state.healthyHabits.setting.nick" enablePortuguese showLanguageSelector :title="$store.state.healthyHabits.setting.nick" class="dropdown" @logOff="logOff" :items="dropdownLoginItems" />
            </base-button>
            </b-nav-item>
            <div v-if="!showInSubmenu">
                <b-nav-item><lang-selector enablePortuguese style="margin: 0px !important" class="d-inline-block"></lang-selector></b-nav-item>
                <b-nav-item v-b-toggle.nav-collapse @click="logOff"><base-button outline fitContent>{{$t('logOff')}}</base-button></b-nav-item>
            </div>
          </b-navbar-nav>
        </b-collapse>
    </b-navbar>
  <loading-anim v-if="$store.state.loading && !$store.state.healthyHabits.hideLoadingIcon" :active="$store.state.loading" fullScreen></loading-anim>
  <base-modal noCloseOnBackdrop noCloseOnScape hideClose bodyClass="text-center" :value="$store.state.healthyHabits.showMeasurableInputModal" :title="$t('enterNewValue')" @hide="$store.state.healthyHabits.showMeasurableInputModal = false">
    <div>
      <base-input name="new-value-input" :min="0" placeholder="" inlineBlock v-model="$store.state.healthyHabits.itemSelected.newValue" type="number">
        <template #append>
          {{$store.state.healthyHabits.itemSelected.measureUnit}}
        </template>
      </base-input>
    </div>
    <div>
      <base-button class="mr-1 my-1" @click="sendMeasurableData()">{{$t('save')}}</base-button><base-button gray outline @click="$store.state.healthyHabits.itemSelected.newValue = $store.state.healthyHabits.itemSelected.currentValue; $store.state.healthyHabits.showMeasurableInputModal = false">{{$t('back')}}</base-button>
    </div>
  </base-modal>
  <base-modal bodyClass="text-center" :value="$store.state.healthyHabits.showGoalCompletedModal" :title="$t('congratulations')" @hide="$store.state.healthyHabits.showGoalCompletedModal = false">
    <div>
      {{$t('goalCompletedText')}}
    </div>
    <div class="my-3">
      <base-button @click="$store.state.healthyHabits.showGoalCompletedModal = false">{{$t('continue')}}</base-button>
    </div>
  </base-modal>
  <base-modal width25 :value="$store.state.healthyHabits.form.show" @hide="healthyHabitsFormModalHidden()">
    <healthy-habits-form inModal loadHabitsOnSave @closeModal="healthyHabitsFormModalHidden()"></healthy-habits-form>
  </base-modal>
  <base-modal width25 :value="$store.state.healthyHabits.showTableLegendModal" @hide="$store.state.healthyHabits.showTableLegendModal = false">
    <h5 class="my-3" style="text-decoration: underline;">{{$t('healthyHabitsGeneral')}}</h5>
    <b-row>
      <b-col cols="12"><b-icon-pencil-square class="blue"></b-icon-pencil-square> {{$t('edit')}}</b-col>
      <b-col cols="12"><b-icon-bar-chart-fill class="orange"></b-icon-bar-chart-fill> {{$t('stadistics')}}</b-col>
      <b-col cols="12"><b-icon-trash class="red"></b-icon-trash> {{$t('removeOrStore')}}</b-col>
      <b-col cols="12"><b-icon-arrow-clockwise class="black"></b-icon-arrow-clockwise> {{$t('restore')}}</b-col>
      <b-col cols="12"><b-icon-save class="description-icon-width"></b-icon-save> {{$t('stored')}}</b-col>
      <b-col cols="12"><b-icon-trophy-fill style="color: #3238C4;"></b-icon-trophy-fill> {{$t('completed')}}</b-col>
      <b-col cols="12">
        <b-progress style="display: inline-grid; min-width: 65px;" :max="100">
            <b-progress-bar :value="50" :label-html="`<span style='font-weight: bold;' class='progressBarTable'>50%</span>`"></b-progress-bar>
        </b-progress> {{$t('progressBar')}}
      </b-col>
    </b-row>
    <h5 class="my-3" style="text-decoration: underline;">{{$t('nonMeasurable')}}</h5>
    <b-row>
      <b-col cols="12"><b-icon-check-lg style="color: #3238C4;"></b-icon-check-lg> {{$t('completed')}}</b-col>
      <b-col cols="12"><b-icon-check-lg style="color: #3238C4;" class="partial-fill-opacity"></b-icon-check-lg> {{$t('partialCompleted')}}</b-col>
      <b-col cols="12"><b-icon-dash style="color: #3238C4;" scale="2"></b-icon-dash> {{$t('freeDay')}}</b-col>
      <b-col cols="12"><b-icon-x-lg></b-icon-x-lg> {{$t('uncompleted')}}</b-col>
    </b-row>
    <h5 class="my-3" style="text-decoration: underline;">{{$t('measurable')}}</h5>
    <b-row>
      <b-col cols="12">{{$t('measurableInfo')}}</b-col>
      <b-col cols="12">{{$t('measurableInfo2')}}</b-col>
      <b-col class="my-3" cols="12"><label style="font-size: 11px;">*{{$t('calendarLegendColorInfo')}}</label></b-col>
    </b-row>
  </base-modal>
  <base-modal width25 :value="$store.state.healthyHabits.showCalendarLegendModal" @hide="$store.state.healthyHabits.showCalendarLegendModal = false">
    <h5 style="text-decoration: underline;" class="my-3">{{$t('healthyHabitsGeneral')}}</h5>
    <p>{{$t('calendarInfo')}}</p>
    <h5 class="my-3" style="text-decoration: underline;">{{$t('nonMeasurable')}}</h5>
    <b-row>
      <b-col cols="12"><span class="cell-style" style="background-color: #3238C4; height: 19px; width: 19px; display: inline-block;">1</span> <span style="display: inline-block !important; vertical-align: middle !important;">{{$t('completed')}}</span></b-col>
      <b-col cols="12"><span class="cell-style partial-fill-opacity" style="background-color: #3238C4; height: 19px; width: 19px; display: inline-block;">1</span> <span style="display: inline-block !important; vertical-align: middle !important;">{{$t('partialCompleted')}}</span></b-col>
      <b-col cols="12"><span class="cell-style linear-gradient" style="background-color: #3238C4; height: 19px; width: 19px; display: inline-block;">1</span> <span style="display: inline-block !important; vertical-align: middle !important;">{{$t('freeDay')}}</span></b-col>
      <b-col cols="12"><span class="cell-style" style="background-color: #979797; height: 19px; width: 19px; display: inline-block;">1</span> <span style="display: inline-block !important; vertical-align: middle !important;">{{$t('uncompleted')}}</span></b-col>
    </b-row>
    <h5 class="my-3" style="text-decoration: underline;">{{$t('measurable')}}</h5>
    <b-row>
      <b-col cols="12"><span class="cell-style" style="background-color: #3238C4; height: 19px; width: 19px; display: inline-block;">1</span> <span style="display: inline-block !important; vertical-align: middle !important;">{{$t('completed')}}</span></b-col>
      <b-col cols="12"><span class="cell-style partial-fill-opacity" style="background-color: #3238C4; height: 19px; width: 19px; display: inline-block;">1</span> <span style="display: inline-block !important; vertical-align: middle !important;">{{$t('partialCompleted')}}</span></b-col>
      <b-col cols="12"><span class="cell-style linear-gradient" style="background-color: #3238C4; height: 19px; width: 19px; display: inline-block;">1</span> <span style="display: inline-block !important; vertical-align: middle !important;">{{$t('filled')}}</span></b-col>
      <b-col cols="12"><span class="cell-style" style="background-color: #979797; height: 19px; width: 19px; display: inline-block;">1</span> <span style="display: inline-block !important; vertical-align: middle !important;">{{$t('uncompleted')}}</span></b-col>
      <b-col class="my-3" cols="12"><label style="font-size: 11px;">*{{$t('calendarLegendColorInfo')}}</label></b-col>
    </b-row>
  </base-modal>
  <base-modal noCloseOnBackdrop noCloseOnScape hideClose bodyClass="text-center" :value="$store.state.healthyHabits.setting.showModal" :title="$t('setting')">
    <b-row>
      <b-col cols="12"><b-form-checkbox class="form-group" switch v-model="$store.state.healthyHabits.setting.showStoredHabits"><span class="label-align" v-html="$t('showStoredHabits')"></span></b-form-checkbox></b-col>
      <b-col cols="12"><b-form-checkbox class="form-group" switch v-model="$store.state.healthyHabits.setting.showGoalCompletedHabits"><span class="label-align" v-html="$t('showGoalCompletedHabits')"></span></b-form-checkbox></b-col>
      <b-col cols="12"><b-form-checkbox class="form-group" switch @change="allowFreeDaysChange" v-model="$store.state.healthyHabits.setting.allowFreeDays"><span class="label-align" v-html="$t('allowFreeDays')"></span></b-form-checkbox></b-col>
      <b-col cols="12"><b-form-checkbox class="form-group" switch v-model="$store.state.healthyHabits.setting.invertedCalendarDays"><span class="label-align" v-html="$t('invertCalendarDays')"></span></b-form-checkbox></b-col>
      <b-col cols="12"><base-input class="input-form-centered" v-model="$store.state.healthyHabits.setting.notifications.email" :tooltip="$t('notificationsEmail')" :placeholder="$t('notificationsEmail')" type="text"></base-input></b-col>
      <b-col cols="12"><base-input class="input-form-centered" v-model="$store.state.healthyHabits.setting.notifications.phone" :tooltip="$t('notificationsPhoneTooltip')" :placeholder="$t('notificationsPhone')" type="text"></base-input></b-col>
    </b-row>
    <div class="my-3">
      <base-button class="mr-2" @click="updateSetting()">{{$t('save')}}</base-button><base-button gray outline @click="resetSetting()">{{$t('back')}}</base-button>
    </div>
  </base-modal>
  <base-dialog :value="showAllowFreeDaysAdvice" :okFn="() => { showAllowFreeDaysAdvice = false }" :cancelFn="() => { showAllowFreeDaysAdvice = false; $store.state.healthyHabits.setting.allowFreeDays = true }" :okBtnText="$t('yes')" :cancelBtnText="$t('no')" :content="$t('allowFreeDaysAdvice')"></base-dialog>
  <arrow-up></arrow-up>
  <router-view class="container-md container-healthy-habits"></router-view>
</IdleTracker>
</template>

<script>
import { BNavbarNav, BNavbar, BNavbarBrand, BNavbarToggle, BCollapse, BNavItem, BIcon, BFormCheckbox, BRow, BCol, BProgress, BProgressBar } from 'bootstrap-vue'
import Dropdown from '@/components/base/dropdown/Dropdown'
import BaseModal from '@/components/base/BaseModal'
import LangSelector from '@/components/base/LangSelector'
import layoutMixin from '@/mixins/layout.mixin'
import healthyHabitsMixin from '@/mixins/healthyHabits.mixin'
import LoadingAnim from '@/components/utils/LoadingAnim'
import BaseDialog from '@/components/base/BaseDialog'
import HealthyHabitsForm from '@/components/views/healthy-habits/HealthyHabitsForm'
import ArrowUp from '@/components/shared/ArrowUp'
import IdleTracker from '@/components/utils/IdleTracker'

export default {
  name: 'healthyHabitsLayout',
  components: {
    Dropdown,
    BaseModal,
    LangSelector,
    LoadingAnim,
    BNavbar,
    BNavbarBrand,
    BNavbarToggle,
    BCollapse,
    BNavItem,
    BIcon,
    BNavbarNav,
    BFormCheckbox,
    BaseDialog,
    BRow,
    BCol,
    HealthyHabitsForm,
    BProgress,
    BProgressBar,
    ArrowUp,
		IdleTracker
  },
  computed: {
    showInSubmenu () {
      return window.innerWidth >= 1200
    },
    currentRouteName () {
      return this.$route.name
    }
  },
  props: {
  },
  mounted () {
  },
  data () {
    return {
      showAllowFreeDaysAdvice: false,
      settingCopy: {
        notifications: {
          phone: null,
          email: null
        },
        showStoredHabits: null,
        showGoalCompletedHabits: null,
        allowFreeDays: null,
        invertedCalendarDays: null
      },
      dropdownLoginItems: [
        {
          title: this.$t('logOff'),
          click: 'logOff'
        }
      ]
    }
  },
  created () {
    if (this.$store.getters['session/isLogged']) {
      this.getUserSetting()
    } else {
      this.logIn()
    }
    this.$store.state.loading = false
  },
  mixins: [healthyHabitsMixin, layoutMixin],
  methods: {
    sendMeasurableData () {
      if (this.$store.state.healthyHabits.table.updatingItem) {
        return
      }
      this.$store.state.healthyHabits.itemSelected.newValue = parseFloat(this.$store.state.healthyHabits.itemSelected.newValue) ? parseFloat(parseFloat(this.$store.state.healthyHabits.itemSelected.newValue).toFixed(2)) : 0
      if (this.$store.state.healthyHabits.itemSelected.newValue < 0) {
        this.$store.dispatch('showInfoAlert', this.$t('mustInsertPositiveValue'))
        return
      }
      if (this.$store.state.healthyHabits.itemSelected.newValue !== this.$store.state.healthyHabits.itemSelected.currentValue) {
        this.sendModifiedData()
      }
      this.$store.state.healthyHabits.showMeasurableInputModal = false
    },
    healthyHabitsFormModalHidden () {
      this.$store.state.healthyHabits.form.show = false
      this.$store.state.healthyHabits.form.editing = false
      this.$store.state.healthyHabits.predefinedHabit.itemIdSelected = null
      this.$store.state.healthyHabits.form.predefinedHabit = null
      this.$store.state.healthyHabits.form.multiUser = false
      if (this.isRouteFromClinicHistory()) {
        this.goHealthyHabitsPath()
      }
    },
    allowFreeDaysChange (value) {
      if (!value) {
        this.showAllowFreeDaysAdvice = true
      }
    },
    showSettingModal () {
      this.settingCopy.notifications.email = this.$store.state.healthyHabits.setting.notifications.email
      this.settingCopy.notifications.phone = this.$store.state.healthyHabits.setting.notifications.phone
      this.settingCopy.showStoredHabits = this.$store.state.healthyHabits.setting.showStoredHabits
      this.settingCopy.showGoalCompletedHabits = this.$store.state.healthyHabits.setting.showGoalCompletedHabits
      this.settingCopy.allowFreeDays = this.$store.state.healthyHabits.setting.allowFreeDays
      this.settingCopy.invertedCalendarDays = this.$store.state.healthyHabits.setting.invertedCalendarDays
      this.$store.state.healthyHabits.setting.showModal = true
    },
    resetSetting () {
      this.$store.state.healthyHabits.setting.showModal = false
      this.$store.state.healthyHabits.setting.notifications.email = this.settingCopy.notifications.email
      this.$store.state.healthyHabits.setting.notifications.phone = this.settingCopy.notifications.phone
      this.$store.state.healthyHabits.setting.showStoredHabits = this.settingCopy.showStoredHabits
      this.$store.state.healthyHabits.setting.showGoalCompletedHabits = this.settingCopy.showGoalCompletedHabits
      this.$store.state.healthyHabits.setting.allowFreeDays = this.settingCopy.allowFreeDays
      this.$store.state.healthyHabits.setting.invertedCalendarDays = this.settingCopy.invertedCalendarDays
    },
    closeTab () {
      window.close()
    },
    onBackButtonClick () {
      if (this.currentRouteName === 'healthyHabits') {
        this.goPatientMenu()
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style lang="scss">
@import "static-appopensalud/css/public/views/healthy_habits.scss";

.navbar-healthy-habits-commom {
  // border-bottom: 1px solid #ddd;
  // background-color: white;
  padding: 2rem 11rem;
  background-color: #E4E4E4;
  @include desktop-xl{
    padding: 2rem 20rem;
  }
}
.navCollapse {
    position: fixed !important;
    top: 4rem;
    right: 1rem !important;
    flex-basis: 100%;
    flex-grow: 1;
    align-items: center;
    @include screen-xl-grid {
      position: sticky !important;
    }
    /* ul{
      padding: 1rem;
    } */
  }
  .navbar-healthy-habits{
    @include screen-xl-grid-max {
      padding-left: 2vw;
      display: block !important;
      padding-right: 0px !important;
    }
  }
  .navbar-items-align {
    display: flex;
    align-items: start;
    @include screen-xl-grid-max {
      justify-content: space-between;
    }
  }
  .navbar-submenu {
    align-items: center !important;
  }
  .nav-item {
  @include desktop {
    margin-right: 0rem;
  }
  @include media(mobile, tablets) {
    padding: 0rem 2rem;
  }
}

  @include screen-xl-grid {
    .navbar-healthy-habits-commom.navbar-expand-xl .navCollapse {
      display: -webkit-box !important;
      display: -ms-flexbox !important;
      display: flex !important;
      -ms-flex-preferred-size: auto;
      flex-basis: auto;
    }
  }
  .fixed-padding-btn-access{
  @include screen-xl-grid-max {
    padding: 0.4rem 1rem !important;
  }
}
.navbar-login{
  padding-left: 2vw !important;
  padding-right: 2vw !important;
}
.doubs-menu-outside{
  position: absolute;
  padding-top: 2rem;
  right: 90px;
  top: 15px;
  cursor: pointer;
}
.config-menu-outside{
  position: absolute;
  padding-top: 2rem;
  right: 60px;
  top: 15px;
  cursor: pointer;
}
.trophy-menu-outside{
  position: absolute;
  padding-top: 2rem;
  right: 120px;
  top: 15px;
}
div[name="new-value-input"] input{
  width: 124px !important;
  max-width: 124px;
}
div[name="new-value-input"] .input-group-text{
  max-width: 123px;
  overflow: hidden;
  @media screen and (min-width: 470px) {
      max-width: 251px;
  }
}
.container-healthy-habits{
  padding-right: 2rem;
  padding-left: 2rem;
}
</style>


// WEBPACK FOOTER //
// src/components/layouts/HealthyHabitsLayout.vue